import React from 'react';

const JournalInsight = () => {
    return (
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">Journal Insights</h2>

            {/* Aim Section */}
            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Aim & Scope</div>
                <div className="about-ed-content-impact">
                    <p>
                        <strong>IMPACT - INTERNATIONAL MULTIDISCIPLINARY PHARMACEUTICAL AND CLINICAL TRENDS </strong> is dedicated to the rapid publication of high-quality articles that advance the frontiers of pharmacy and medical sciences. As an esteemed, peer-reviewed journal, IMPACT serves as a dynamic platform for researchers, clinicians, and industry professionals to share innovative findings that contribute to the evolution of drug discovery, pharmaceutical advancements, and medical science….
                    </p>
                </div>
            </div>

            {/* Scope Section */}
            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Subject Areas</div>
                <div className="about-ed-content-impact">
                    <p>
                        Pharmaceutical, Medical & Biological Science (General)
                    </p>
                </div>
            </div>

            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Publishing Timeline</div>
                <div className="about-ed-content-impact">
                    <div className="header-additional-info-pm">
                        <div className="header-additional-card-pm">
                            <h3>2 Days</h3>
                            <p>Time to first decision</p>
                        </div>
                        <div className="header-additional-card-pm">
                            <h3>5 Days</h3>
                            <p>Review time</p>
                        </div>
                        <div className="header-additional-card-pm">
                            <h3>12 Days</h3>
                            <p>Submission to acceptance</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Acceptance rate</div>
                <div className="about-ed-content-impact">
                    <p>
                        85%
                    </p>
                </div>
            </div>

            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Publication charges</div>
                <div className="about-ed-content-impact">
                    <p>
                        ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default JournalInsight;
